module.exports = __webpack_public_path__ + "static/media/right-arrow-new.e158ec09.svg";